import React from 'react';
import { Link } from 'react-router-dom';

import Table from '@mui/material/Table';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableContainer from '@mui/material/TableContainer';

import Title from '../../../common/Title';

export default function SearchViewDevice({ deviceData }) {
  if (!deviceData || Object.keys(deviceData).length === 0) {
    return (
      <Title content="No device found." variant="subtitle2" gutterBottom />
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} stickyHeader>
      <TableHead>
          <TableRow>
            <TableCell>ICCID</TableCell>
            <TableCell align="left">Status</TableCell>
            <TableCell align="left">Rate Plan</TableCell>
            <TableCell align="left">Usage</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow
            key={deviceData.iccid}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
              <Link to={`${deviceData.iccid}`}>
                <Button size="small">{deviceData.iccid}</Button>
              </Link>
            </TableCell>
            <TableCell>{deviceData.status}</TableCell>
            <TableCell>{deviceData.rate_plan}</TableCell>
            <TableCell>{deviceData.cycle_data_usage}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
